import React from 'react';
import bgImage from '../../assets/products/hero.png';
import Slider from 'react-slick';
import card from '../../assets/products/card.png';

const items = new Array(8).fill({
    image: card,
    title: 'Recorded Sessions',
    desc: 'Access to recorded classes for review and revision. Flexible viewing options for students with different schedules.',
    link: '',
});

const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    slidesToShow: 3.5,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 3,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
};

const Elearning = () => {
    return (
        <div className="flex flex-col gap-16">
            {/* Hero Section */}
            <div className='h-[55vh] md:h-[70vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'

                style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="absolute inset-0 bg-black/50 z-0"></div>
                <div className="z-10 px-6 sm:px-10 md:px-16 max-w-4xl">
    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-snug md:leading-tight mb-4 md:mb-6">
        Avinya E-learning Platform
    </h1>
    <p className="text-base sm:text-lg md:text-xl">
        The Ultimate Learning Hub for Students
    </p>
</div>

            </div>

            {/* Section Title */}
            <section className="text-center px-4">
                <h2 className="text-3xl font-semibold mb-4 text-gray-800">Student Panel Features List</h2>
            </section>

            {/* Slider Section */}
            <div className="px-10">
                <Slider {...settings}>
                    {items.map((item, index) => (
                        <div key={index} className="px-3">
                            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300">
                                <img src={item.image} alt="feature" className="w-full h-48 object-cover" />
                                <div className="p-5 flex flex-col items-center gap-3">
                                    <h3 className="text-lg font-semibold text-center text-gray-800">{item.title}</h3>
                                    <p className="text-sm text-gray-600 text-center">{item.desc}</p>
                                    <button className="bg-[#006BD3] hover:bg-blue-700 transition text-white px-4 py-1 rounded mt-auto">
                                        View More
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Admin Features Section */}
            <section className="text-center px-4">
                <h2 className="text-3xl font-semibold mb-4 text-gray-800">Admin Features</h2>
            </section>

            <div className="px-10">
                <Slider {...settings}>
                    {items.map((item, index) => (
                        <div key={index} className="px-3">
                            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300">
                                <img src={item.image} alt="feature" className="w-full h-48 object-cover" />
                                <div className="p-5 flex flex-col items-center gap-3">
                                    <h3 className="text-lg font-semibold text-center text-gray-800">{item.title}</h3>
                                    <p className="text-sm text-gray-600 text-center">{item.desc}</p>
                                    <button className="bg-[#006BD3] hover:bg-blue-700 transition text-white px-4 py-1 rounded mt-auto">
                                        View More
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Benefits Section */}
            <section className="text-center px-6 max-w-3xl mx-auto">
                <h2 className="text-3xl font-semibold text-gray-800 mb-4">Benefits of Avinya E-learning Platform</h2>
                <p className="text-gray-600">
                    E-learning platforms have revolutionized the educational landscape, offering numerous advantages for students, educators, and institutions.
                </p>
            </section>

            {/* Static Cards Section */}
            <div className="flex flex-wrap justify-center gap-6 px-6 pb-20">
                {items.map((item, index) => (
                    <div key={index} className="w-[292px] bg-white rounded-xl shadow-md hover:shadow-lg transition duration-300 overflow-hidden">
                        <img src={item.image} alt="feature" className="w-full h-48 object-cover" />
                        <div className="p-5 flex flex-col items-center gap-3">
                            <h3 className="text-lg font-semibold text-center text-gray-800">{item.title}</h3>
                            <p className="text-sm text-gray-600 text-center">{item.desc}</p>
                            <button className="bg-[#006BD3] hover:bg-blue-700 transition text-white px-4 py-1 rounded mt-auto">
                                View More
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Elearning;
